<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/odoo-partner.vue";

export default {
  name: 'OdooPartnerCreateModal',
  extends: ModelCreateModal,
  props: {
    modalTitle: {
      default() {
        return this.lodash.startCase(this.$t('create {something} new', {something: this.$t('odoo_partners.singular')}))
      }
    },
    resourceRoute: {default: 'odoo_partners'},
    modelVariable: {default: 'odoo_partner'},
    form: {
      default() {
        return FormsModel;
      }
    },
    size: {default: 'md'},
  },
  methods: {
    store(value) {
      this.loading = true
      return this.$axios.post('/odoo/partners', {
        ...value,
        company_id: process.env.VUE_APP_ODOO_COMPANY_ID,
      }).finally(() => this.loading = false);
    }
  },
}
</script>

<style scoped>
::v-deep {
  .modal-header, .modal-footer {
    border: none;
  }

  .modal-header {
    padding-bottom: 0;
  }

  .modal-body {
    padding-block: 0;
  }
}
</style>